// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".ele-form-dialog .el-dialog__body{padding:10px 20px}.ele-form-dialog .ele-form-btns{float:right;margin-top:10px}", ""]);
// Exports
module.exports = exports;
